import { CargoEntity, CargoTypeEntity, TowOnTypeEntity } from 'Models/Entities';
import { createContext, useContext } from 'react';

export interface VehicleTabContextType {
	previousCargo: { previous: boolean };
	cargoTypes: CargoTypeEntity[];
	previousCargoList: CargoEntity[];
	setPreviousCargoList: (newCargos: CargoEntity[]) => void;
	refetchVehicleTabData: () => void;
	vehicleMeasurementPrices: { [key: string]: number };
	trailerMeasurementPrices: { [key: string]: number };
	towOnTypes: TowOnTypeEntity[];
	prices?: { [id: string]: number };
	trailerPrices?: { [id: string]: number };
	isGuest: boolean;
	isUserLoading: boolean;
}

const VehicleTabContext = createContext<VehicleTabContextType | undefined>(undefined);

export const VehicleTabProvider = VehicleTabContext.Provider;

export const useVehicleTabContext = () => {
	const context = useContext(VehicleTabContext);
	if (!context) {
		throw new Error('useVehicleTabContext must be used within a VehicleTabProvider');
	}
	return context;
};
